import { REHYDRATE } from 'redux-persist';
import update from 'immutability-helper';
import {
  LOGIN_INIT,
  AUTHENTICATE_USER_BEGIN,
  AUTHENTICATE_USER_SUCCESS,
  AUTHENTICATE_USER_FAIL,
  USER_PROFILE_FETCH_BEGIN,
  USER_PROFILE_FETCH_SUCCESS,
  USER_PROFILE_FETCH_FAIL,
  LOGOUT,
  LOGIN_CHECK_BEGIN,
  LOGIN_CHECK_FAIL,
  LOGIN_TIMED_OUT,
  COMPANY_PROFILE_SETUP_STATUS_CHECK_SUCCESS,
  COMPANY_PROFILE_SETUP_STATUS_CHECK_FAIL,
  USER_RESET_PASSWORD_BEGIN,
  USER_RESET_PASSWORD_SUCCESS,
  USER_RESET_PASSWORD_FAIL,
  USER_VALID_TOKEN_FAIL,
  USER_VALID_TOKEN_SUCCESS,
  USER_CHANGE_PASSWORD_BEGIN,
  USER_CHANGE_PASSWORD_SUCCESS,
  USER_CHANGE_PASSWORD_FAIL,
} from 'actions/loginStateActions';
import { ANY_FIELD_UPDATE, STATE_DETAIL_CHANGE, updatedObject } from '../actions/formActions';

const INITIAL_STATE = {
  profile: {
    id: null,
    roleId: null,
  },
  status: 'uninitialized',
};

export default function loginStateReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE: {
      if (action.payload != null && action.payload.loginState != null)
        return action.payload.loginState;
      return state;
    }

    case LOGIN_INIT:
      return { ...INITIAL_STATE, status: 'initialized' };
    case AUTHENTICATE_USER_BEGIN:
      return { ...INITIAL_STATE, status: 'loginInProgress' };

    case AUTHENTICATE_USER_SUCCESS:
      return { ...state, status: 'success' };

    case AUTHENTICATE_USER_FAIL:
      return { ...INITIAL_STATE, status: 'failed', failReason: action.reason };

    case USER_PROFILE_FETCH_BEGIN:
      return { ...state, status: 'fetching' };

    case USER_PROFILE_FETCH_SUCCESS:
      return update(state, {
        profile: { $set: action.profile },
        status: { $set: action.status || 'ready' },
      });

    case USER_PROFILE_FETCH_FAIL:
      return { ...INITIAL_STATE, status: 'failed', failReason: action.reason };
    case LOGIN_CHECK_BEGIN: {
      const { failReason, ...newState } = state;

      return Object.assign({}, newState, {
        loginInProgress: true,
      });
    }

    case LOGIN_CHECK_FAIL: {
      const { loginInProgress, ...newState } = state;

      return Object.assign({}, newState, {
        failReason: action.reason,
      });
    }

    case COMPANY_PROFILE_SETUP_STATUS_CHECK_SUCCESS:
      return update(state, {
        profile: {
          companyMaps: {
            0: {
              company: {
                isProfileSetup: {
                  $set: action.data.isProfileSetup,
                },
              },
            },
          },
        },
      });

    case COMPANY_PROFILE_SETUP_STATUS_CHECK_FAIL:
      return { ...state, failReason: action.reason };

    case LOGOUT:
      return { ...INITIAL_STATE, status: 'logout' };

    case LOGIN_TIMED_OUT:
      return { ...INITIAL_STATE, status: 'timedOut' };

    case USER_RESET_PASSWORD_BEGIN:
      return { status: 'begin' };
    case USER_RESET_PASSWORD_SUCCESS:
      return { status: 'resent' };
    case USER_RESET_PASSWORD_FAIL:
      return { status: 'failed', failReason: action.reason };

    case USER_VALID_TOKEN_FAIL:
      return { status: 'invalid-token' };
    case USER_VALID_TOKEN_SUCCESS:
      return { status: 'valid-token' };
    case USER_CHANGE_PASSWORD_BEGIN:
      return { status: 'begin' };
    case USER_CHANGE_PASSWORD_SUCCESS:
      return { status: 'success' };
    case USER_CHANGE_PASSWORD_FAIL:
      return { status: 'failed' };

    case ANY_FIELD_UPDATE:
      if (action.storeName !== 'loginState') return state;

      return updatedObject(state, action.accessPath, action.newVal);

    case STATE_DETAIL_CHANGE:
      if (action.storeName !== 'loginState') return state;
      return { ...state, [action.key]: action.newVal };

    default:
      return state;
  }
}
